<template>
  <section class='section'>
    <modal-groups
      v-if="modalGroups"
      :close="showModal"
      :userGroupsList="userGroupsList"
      :createUserGroup="createUserGroup"
      :loadingAdd="loadingAdd"
    />
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <h1>Usuarios: {{ totalProducts }}</h1>
        </div>
      </div>
      <div class="level-left">
      </div>
      <div class="level-right">
        <div class="level-item">
          <button
            class="button"
            type="button"
            :class="{ 'is-loading': isLoading }"
            @click="getCsvDownload"
          >
          Descargar
        </button>
        </div>
        <div class="level-item">
          <div class="control">
            <input class="input" type="text" v-model="search" @keyup="searchUser" placeholder="Buscador...">
          </div>
        </div>
        <div class="level-item">
          <div class="select is-fullwidth">
            <select class="select" v-model="filterGroup" @change="filterByGroup">
              <option value="">Todos</option>
              <template v-for="group in userGroupsList">
                  <option :key="group.id" :value="group.id"> {{group.name}} </option>
                </template>
            </select>
          </div>
        </div>
        <div class="level-item">
          <button @click="toggleDatePicker" v-if="!showDatePicker" class="button">
            Filtrar por fecha
          </button>
          <div v-else style="max-width: 150px; overflow: hidden;">
            <v-date-picker
              mode="range"
              v-model="date"
              :max-date="today"
              @input="onDateChange"
            />
          </div>
          <button @click="resetDate" v-if="showDatePicker" class="button" style="padding: 4px;">
            <span class="material-icons">
              restart_alt
            </span>
          </button>
        </div>
        <!-- <div class="level-item">
          <button class="button is-info" @click="showModal"> Grupos </button>
        </div> -->
      </div>
    </nav>
    <div
      class="box is-inline-flex is-align-items-center p-2"
      style="border-left: 4px solid #3273dc; background-color: #f9f9f9; gap: 10px"
    >
      <button
        class="button is-light is-small ml-2"
        @click="toggleSelectAll(true)"
      >
        <span class="icon is-small">
          <i class="material-icons" style="font-size: 18px;">check_box</i>
        </span>
        <span>Seleccionar página</span>
      </button>
      <p class="has-text-weight-medium">Usuarios seleccionados: {{ selectedUsers.length }}</p>
      <button class="button is-info is-light is-small" @click="openModalAddGroup">
        <span class="icon is-small">
          <i class="material-icons" style="font-size: 18px;">groups</i>
        </span>
        <span>Asignar Grupo</span>
      </button>
      <button
        class="button is-danger is-light is-small ml-2"
        @click="toggleSelectAll(false)"
      >
        <span class="icon is-small">
          <i class="material-icons" style="font-size: 18px;">delete</i>
        </span>
        <span>Limpiar</span>
      </button>
    </div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <base-table
          class="is-bordered is-striped is-narrow is-fullwidth is-hoverable bankingTable"
          :columns="computedColumnsData"
          :data="usersList"
          :loading=loading
        >
        <div
          class="field"
          slot="config"
          slot-scope="scope"
        >
          <input
            :id="`switchStatus-${scope.row.id}`"
            type="checkbox"
            name="switchStatusUser"
            class="switch is-rounded is-info is-small"
            :checked="!scope.row.blocked ? 'checked' : ''"
            @click="deactivateUser(scope.row)"
          >
          <label
            :for="`switchStatus-${scope.row.id}`"
          >
          </label>
        </div>
        <div
          slot="removeColumn"
          slot-scope="scope"
        >
          <i class="material-icons icon-action" @click="openModalRemove(scope.row)">delete_forever</i>
        </div>
        <template v-slot:select="scope">
          <input
            type="checkbox"
            :value="scope.row.id"
            :checked="selectedUsers.includes(scope.row.id)"
            @change="toggleUserSelection(scope.row.id)"
          />
        </template>
        </base-table>
      </div>
    </div>
    <base-pagination
      class="is-medium"
      :page="page"
      :pages="parseInt(pages)"
      :action="paginator"
      :loading="loading"
    />
    <modal-remove
      v-if="isShowModalRemove"
      :close="closeModalRemove"
      :action="removeProduct"
      :removeProductData="removeProductData"
    />
    <modal-add-user-group
      v-if="modalAddGroup"
      :close="closeModalAddGroup"
      :addGroup="addGroup"
      :loadingAdd="loadingAddGroup"
    />
  </section>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import mixin from '../../mixin/validateDate'
// const DEFAULT_DISPLAY_SIZE = 10
const ADMIN_PARRA_ID = 33

export default {
  mixins: [mixin],
  name: 'Usuarios',
  components: {
    BaseTable: () => import('@/components/Table'),
    BasePagination: () => import('@/components/BasePagination'),
    ModalGroups: () => import('@/components/Customers/ModalGroups'),
    ModalRemove: () => import('@/components/users/ModalRemove'),
    ModalAddUserGroup: () => import('@/components/Customers/ModalAddUserGroup')
  },
  data () {
    return {
      search: '',
      page: 1,
      pages: '',
      totalProducts: 0,
      loading: false,
      isLoading: false,
      usersList: [],
      date: {},
      today: moment().add(1, 'days').format('YYYY-MM-DD'),
      showDatePicker: false,
      showAdditionalColumn: false,
      isShowModalRemove: false,
      removeProductData: null,
      selectedUsers: [],
      selectAll: false,
      loadingAddGroup: false,
      modalAddGroup: false,
      columnsData: [
        {
          id: 'id',
          header: 'Id',
          class: 'column-mobile'
        },
        {
          id: 'removeColumn',
          name: 'removeColumn',
          header: '',
          class: 'column-mobile',
          show: this.showAdditionalColumn
        },
        {
          id: 'select',
          name: 'select',
          header: '',
          class: 'column-mobile'
        },
        {
          id: 'name',
          header: 'Usuario',
          class: 'column-mobile',
          type: 'link',
          link: true,
          route: (row) => `usuarios/detalle/${row.id}`
        },
        { id: 'email', header: 'Correo', class: 'is-hidden-touch' },
        { id: 'phone', header: 'Télefono', class: 'is-hidden-touch' },
        {
          id: 'created_at',
          header: 'Fecha',
          class: 'column-mobile',
          accessor: (row) => `${this.formatDateTimestamp(row.createdAt)} ${this.formatDateTimestampHour(row.createdAt)}`
        },
        {
          id: 'birthdate',
          header: 'Fecha de Nacimiento',
          class: 'column-mobile',
          accessor: (row) => {
            if (row.birthdate && moment(row.birthdate).isValid()) {
              return moment(row.birthdate).format('DD-MM-YYYY')
            } else {
              return 'El usuario no proporciono la fecha'
            }
          }
        },
        { id: 'balance', header: '$ (Recompensa)', class: 'column-mobile', accessor: (row) => this.numberFormat(row.balance) },
        { id: 'totalproducts', header: 'Productos', class: 'column-mobile', accessor: (row) => row.totalproducts || 0 },
        { id: 'totalsales', header: '# de Ventas', class: 'column-mobile', accessor: (row) => row.totalsales || 0 },
        { id: 'totalpurchases', header: '# de Compras', class: 'column-mobile', accessor: (row) => row.totalpurchases || 0 },
        {
          id: 'status',
          header: 'Bloqueado',
          accessor: (row) => row.blocked ? 'Si' : 'No'
        },
        {
          id: 'config',
          name: 'config',
          header: 'Activo',
          class: 'column-mobile has-text-centered'
        }
      ],
      modalGroups: false,
      userGroupsList: [],
      loadingAdd: false,
      filterGroup: '',
      startDate: '',
      endDate: ''
    }
  },
  methods: {
    ...mapMutations(['setAuthenticationValue']),
    ...mapActions(['getCustomers', 'userUpdateStatus', 'getUsergroups', 'createUsergroups', 'csvDownloadUsers', 'addTemporalNotification', 'removeUserById', 'addUsersToGroup']),
    paginator (page) {
      this.page = page
      this.loading = true

      const { filter, search, startDate, endDate } = this.$router.history.current.query
      this.filterGroup = filter === '' || filter === undefined ? this.filterGroup : parseInt(filter, 10)
      this.search = search === '' ? this.search : search
      this.startDate = startDate === '' ? this.startDate : startDate
      this.endDate = endDate === '' ? this.endDate : endDate

      this.$router.push({ name: 'usuarios', query: { page: page, filter: this.filterGroup, search: this.search, startDate: this.startDate, endDate: this.endDate } })

      this.getCustomers({ page, search: this.search, filterGroup: this.filterGroup, startDate: this.startDate, endDate: this.endDate })
        .then(resp => {
          this.loading = false
          this.usersList = resp.payload
          this.pages = resp.totalPages
          this.totalProducts = resp.total
        })
    },
    searchUser ({ target }) {
      this.page = 1
      if (target.value.length >= 3 || target.value.length === 0) {
        this.search = target.value
        this.$router.push({ name: 'usuarios', query: { page: this.page, search: target.value, filter: this.filterGroup, startDate: this.startDate, endDate: this.endDate } })
        this.getCustomers({ page: this.page, search: target.value, filterGroup: this.filterGroup, startDate: this.startDate, endDate: this.endDate })
          .then(resp => {
            this.usersList = resp.payload
            this.pages = resp.totalPages
            this.totalProducts = resp.total
            this.loading = false
          })
      }
    },
    deactivateUser (data) {
      let statusUpdate = !data.blocked
      let userId = data.id
      let dataUpdate = { statusUpdate, userId }
      this.userUpdateStatus(dataUpdate)
        .then(resp => {
          this.loading = true
          this.getCustomers({ page: 1, search: '' })
            .then(resp => {
              this.usersList = resp.payload
              this.pages = resp.totalPages
              this.totalProducts = resp.total
              this.loading = false
            })
        })
    },
    showModal () {
      this.modalGroups = !this.modalGroups
    },
    createUserGroup (data) {
      this.loadingAdd = true
      return this.createUsergroups(data)
        .then(response => {
          return this.getUsergroups()
            .then(groups => {
              this.userGroupsList = groups
              this.loadingAdd = false
              return true
            })
        })
    },
    filterByGroup ({ target }) {
      this.page = 1
      this.$router.push({ name: 'usuarios', query: { page: this.page, search: this.search, filter: target.value } })
      this.getCustomers({ page: this.page, search: this.search, filterGroup: target.value })
        .then(resp => {
          this.usersList = resp.payload
          this.pages = resp.totalPages
          this.totalProducts = resp.total
          this.loading = false
        })
    },
    getCsvDownload () {
      this.isLoading = true
      this.csvDownloadUsers({ search: this.search, filterGroup: this.filterGroup, startDate: this.startDate, endDate: this.endDate })
        .then(resp => {
          if (resp) {
            const exportName = 'Export users.csv'
            console.log(resp, 'test')
            const blob = new Blob([resp], { type: 'text/csv;charset=utf-8;' })
            if (navigator.msSaveBlob) {
              navigator.msSaveBlob(blob, exportName)
            } else {
              const link = document.createElement('a')
              if (link.download !== undefined) {
                const url = URL.createObjectURL(blob)
                link.setAttribute('href', url)
                link.setAttribute('download', exportName)
                link.style.visibility = 'hidden'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
              }
            }
          } else {
            this.addTemporalNotification({ type: 'danger', message: 'Error en la descarga' })
          }
          this.isLoading = false
        })
    },
    onDateChange (newDate) {
      if (newDate == null) return null

      this.startDate = moment(newDate?.start).format('YYYY-MM-DD')
      this.endDate = moment(newDate?.end).format('YYYY-MM-DD')

      this.$router.push({ name: 'usuarios', query: { page: this.page, search: this.value, filter: this.filterGroup, startDate: this.startDate, endDate: this.endDate } })

      this.getCustomers({ page: 1, search: this.search, startDate: this.startDate, endDate: this.endDate })
        .then(resp => {
          this.usersList = resp.payload
          this.pages = resp.totalPages
          this.totalProducts = resp.total
          this.loading = false
        })
    },
    toggleDatePicker () {
      this.showDatePicker = !this.showDatePicker
    },
    resetDate () {
      this.date = {}
      this.showDatePicker = false
      this.startDate = ''
      this.endDate = ''
      this.page = 1

      this.$router.push({ name: 'usuarios', query: { page: this.page, search: this.value, filter: this.filterGroup, startDate: this.startDate, endDate: this.endDate } })
      this.getCustomers({ page: 1, search: this.search, startDate: this.startDate, endDate: this.endDate })
        .then(resp => {
          this.usersList = resp.payload
          this.pages = resp.totalPages
          this.totalProducts = resp.total
          this.loading = false
        })
    },
    closeModalRemove () {
      this.removeProductData = null
      this.isShowModalRemove = false
    },
    openModalRemove (data) {
      this.removeProductData = data
      this.isShowModalRemove = true
    },
    async removeProduct (productId) {
      const response = await this.removeUserById(productId)

      this.getCustomers({ page: this.page, search: this.search, startDate: this.startDate, endDate: this.endDate })
        .then(resp => {
          this.usersList = resp.payload
          this.pages = resp.totalPages
          this.totalProducts = resp.total
          this.loading = false
        })

      return response
    },
    toggleUserSelection (userId) {
      if (this.selectedUsers.includes(userId)) {
        this.selectedUsers = this.selectedUsers.filter(id => id !== userId)
      } else {
        this.selectedUsers.push(userId)
      }
    },
    toggleSelectAll (select) {
      if (select) {
        this.usersList.forEach(user => {
          if (!this.selectedUsers.includes(user.id)) {
            this.selectedUsers.push(user.id)
          }
        })
        this.selectAll = true
      } else {
        this.selectedUsers = []
        this.selectAll = false
      }
    },
    closeModalAddGroup () {
      this.modalAddGroup = false
    },
    openModalAddGroup () {
      this.modalAddGroup = true
    },
    addGroup (groupId) {
      this.loadingAddGroup = true
      this.addUsersToGroup({ userIds: this.selectedUsers, groupId })
        .finally(() => {
          this.loadingAddGroup = false
          this.closeModalAddGroup()
          this.selectedUsers = []
        })
    },
    parseLocalDate (dateString) {
      if (!dateString) return null
      const [y, m, d] = dateString.split('-').map(Number)
      return new Date(y, m - 1, d)
    }
  },
  beforeMount () {
    this.loading = true
    this.showAdditionalColumn = this.$store.state.authentication.adminId === ADMIN_PARRA_ID

    const { page, filter, search, startDate, endDate } = this.$router.history.current.query
    this.page = (page === '' || page === undefined) ? this.page : parseInt(page, 10)
    this.filterGroup = filter === '' || filter === undefined ? this.filterGroup : parseInt(filter, 10)
    this.search = search === '' ? this.search : search
    this.startDate = startDate === '' ? this.startDate : startDate
    this.endDate = endDate === '' ? this.endDate : endDate

    this.date = {
      start: this.parseLocalDate(startDate),
      end: this.parseLocalDate(endDate)
    }
    this.showDatePicker = this.showDatePicker = !!(startDate && endDate)

    this.getCustomers({ page: this.page, filterGroup: this.filterGroup, search: this.search, startDate: this.startDate, endDate: this.endDate })
      .then(resp => {
        this.usersList = resp.payload
        this.pages = resp.totalPages
        this.totalProducts = resp.total
        this.loading = false
      })
    this.getUsergroups()
      .then(groups => {
        this.userGroupsList = groups
      })
  },
  computed: {
    computedColumnsData () {
      return this.columnsData
        .filter(column => {
          if (column.id === 'removeColumn') {
            return this.showAdditionalColumn
          }
          return true
        })
    }
  }
}
</script>
<style scoped>
  h2 {
    margin-top: 40px;
    margin-bottom: 40px;
    text-align: center;
    font-weight: 700;
  }
  .section {
    width: 100%;
    padding: 0 20px 0 20px;
  }
</style>
